module.exports = __webpack_public_path__ + "img/shop.b2a789ca.png";